<template>
  <div class="enterprise-member">
    <el-table
      border
      size="mini"
      :data="data"
      v-loading="loading"
      style="width: 100%"
    >
      <el-table-column label="会员姓名" align="center" prop="name" />
      <el-table-column label="会员电话" align="center" prop="mobilePhone" />
      <el-table-column label="注册日期" align="center" prop="createTime" />
      <el-table-column label="合伙人姓名" align="center" prop="parentName" />
      <el-table-column label="已领取总金额" align="center" prop="received" />
      <el-table-column label="未领取总金额" align="center" prop="unReceived" />
    </el-table>
    <div class="pageBox" style="margin-top: 10px;width: 100%;text-align: right;">
      <el-pagination
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="params.pageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="params.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import { getPanelList as getList } from 'api/request'
  export default {
    data() {
      return {
        params: {
          enterpriseId: undefined,
          pageIndex: 1,
          pageSize: 10
        },
        total: 0,
        loading: false,
        data: []
      }
    },
    methods: {
      initData(enterpriseId) {
        this.params.enterpriseId = enterpriseId
        this.getList()
      },
      async getList() {
        this.loading = true
        const res = await getList(this.params)
        if (res) {
          const { rows, total } = res
          this.data = Array.isArray(rows) ? rows : []
          this.total = total && total > 0 ? total : 0
        }
        this.loading = false
      },
      sizeChange(val) {
        this.params.pageSize = val
        this.getList()
      },
      currentChange(val) {
        this.params.pageIndex = val
        this.getList()
      },
    }
  }
</script>
